// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".download[data-v-023e45f5]{margin:8rem;background-color:#fff;padding:8rem 1rem}.brand-btn[data-v-023e45f5]{line-height:1.8;height:1.8em;border-radius:.9em;padding:0 .7em;background-color:#000;color:#fff;margin-right:1em}", ""]);
// Exports
module.exports = exports;
